const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const getGroupDetails = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_GROUP_DETAILS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_GROUP_DETAILS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state, ...INITIAL_STATE }
  }
};
  
export default getGroupDetails;